import { render, staticRenderFns } from "./PageLayout.vue?vue&type=template&id=6c1c81e1&scoped=true&"
import script from "./PageLayout.vue?vue&type=script&lang=ts&"
export * from "./PageLayout.vue?vue&type=script&lang=ts&"
import style0 from "./PageLayout.vue?vue&type=style&index=0&id=6c1c81e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1c81e1",
  null
  
)

export default component.exports